import React from 'react';

function ProfileInfoSection({ profile }) {
  if (!profile) {
    return <p className="body-large">User has not set up their profile yet.</p>;
  }

  return (
    <div className="profile-info" style={{ marginBottom: '32px' }}>
      <h3 className="heading-3">Profile Information</h3>
      <div className="info-row">
        <span className="info-label">Age:</span>
        <span className="info-value">{profile.age} years</span>
      </div>
      <div className="info-row">
        <span className="info-label">Gender:</span>
        <span className="info-value" style={{ textTransform: 'capitalize' }}>{profile.gender}</span>
      </div>
      <div className="info-row">
        <span className="info-label">Height:</span>
        <span className="info-value">{profile.height_feet}' {profile.height_inches}"</span>
      </div>
      <div className="info-row">
        <span className="info-label">Weight:</span>
        <span className="info-value">{profile.weight} lbs</span>
      </div>
      <div className="info-row">
        <span className="info-label">Goal Weight:</span>
        <span className="info-value">{profile.goal_weight} lbs</span>
      </div>
      <div className="info-row">
        <span className="info-label">Activity Level:</span>
        <span className="info-value" style={{ textTransform: 'capitalize' }}>
          {profile.activity_level.replace('_', ' ')}
        </span>
      </div>
      <div className="divider"></div>
      <div className="info-row highlight">
        <span className="info-label">BMR:</span>
        <span className="info-value">{profile.bmr} cal/day</span>
      </div>
      <div className="info-row highlight">
        <span className="info-label">TDEE:</span>
        <span className="info-value">{profile.tdee} cal/day</span>
      </div>
      <div className="info-row highlight">
        <span className="info-label">Daily Target:</span>
        <span className="info-value">{profile.daily_target} cal/day</span>
      </div>
    </div>
  );
}

export default ProfileInfoSection;